import { render, staticRenderFns } from "./FilesModal.vue?vue&type=template&id=330787f8&scoped=true&"
import script from "./FilesModal.vue?vue&type=script&lang=js&"
export * from "./FilesModal.vue?vue&type=script&lang=js&"
import style0 from "./FilesModal.vue?vue&type=style&index=0&id=330787f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330787f8",
  null
  
)

export default component.exports